import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledAiMenuComponent } from "./ai-menu-component.scss";
import MiniLinkItem from "../components/mini-link-item/mini-link-item";
import MenuDivider from "../components/menu-divider/menu-divider";
import DescriptiveLinkBlock from "../components/descriptive-link-block/descriptive-link-block";
import { AI_PRODUCTS_LINKS, AI_RESOURCES_LINKS, IMPACT_WITH_AI_IMG } from "./consts";
import { createLocalizeLink } from "../index.js";
const AI_VIDEO_LINK = "https://youtube.com/watch?si=jsf3ESu9DNg-zGTE&v=FsrNMGBq268&feature=youtu.be";
const AiMenuComponent = ({ translate, menuId, onLinkClick, headerCatalogLinks })=>{
    const onLinkClickWithMenuId = (event, link, text)=>onLinkClick({
            menuId,
            link,
            event,
            text
        });
    const localizeLink = createLocalizeLink(headerCatalogLinks);
    const localizedAiProductsLinks = AI_PRODUCTS_LINKS.map(localizeLink);
    const localizedAiResourcesLinks = AI_RESOURCES_LINKS.map(localizeLink);
    return /*#__PURE__*/ _jsxs(StyledAiMenuComponent, {
        className: "menu-component three-column-layout",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "ai-products-section",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "section-title align-to-link",
                        children: translate("header.tabs.ai.workCapabilities.title")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "products-container",
                        children: localizedAiProductsLinks.map(({ Icon, title, description, link, isEarlyAccess }, index)=>{
                            const getTitleIcon = ()=>{
                                if (isEarlyAccess) return ()=>/*#__PURE__*/ _jsx("span", {
                                        className: "title-badge",
                                        children: translate("header.menuItem.earlyAccess")
                                    });
                                return undefined;
                            };
                            return /*#__PURE__*/ _jsx(DescriptiveLinkBlock, {
                                Icon: Icon,
                                title: translate(title),
                                description: translate(description),
                                link: link,
                                TitleIcon: getTitleIcon(),
                                onClick: (event)=>onLinkClickWithMenuId(event, link, title)
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuDivider, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "ai-resources-section",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "section-title align-to-link",
                        children: translate("header.tabs.ai.resources.title")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "resources-container",
                        children: localizedAiResourcesLinks.map(({ Icon, text, link }, index)=>/*#__PURE__*/ _jsx(MiniLinkItem, {
                                Icon: Icon,
                                text: translate(text),
                                link: link,
                                onClick: (event)=>onLinkClickWithMenuId(event, link, text)
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuDivider, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "ai-impact-section",
                children: /*#__PURE__*/ _jsxs("a", {
                    href: AI_VIDEO_LINK,
                    className: "impact-link",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: (event)=>onLinkClickWithMenuId(event, AI_VIDEO_LINK, "Amplify your impact with AI"),
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: IMPACT_WITH_AI_IMG,
                            alt: "Amplify your impact with AI",
                            className: "impact-image"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "impact-text",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "impact-title",
                                    children: translate("header.tabs.ai.impact.title")
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "impact-link-text",
                                    children: [
                                        translate("header.tabs.ai.impact.watchNow"),
                                        " ›"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default AiMenuComponent;
